import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import * as theme from '../../../theme';
import TruCard from "../../TruCard";
import OnboardingStatusItem from "../items/OnboardingStatusItem";
import TrainingContentContext from '../../../contexts/TrainingContentContext';
import { sortPeople } from "../../../functions/Sorting";

export default function OnboardingStatusList(props) {
  const [sortedPractitionerList, setSortedPractitionerList] = useState(sortPeople([]));
  const navigate = useNavigate();

  useEffect(() => {
    if (props && props.practitionerList != null) {
      setSortedPractitionerList(sortPeople(props.practitionerList));
    }
  }, [props.practitionerList]);

  // Function to build the onboarding object for each practitioner
  const buildOnboardingObject = (practitioner) => {
    const onboarding = {
      form: false,
      training: false,
      cardOnFile: false,
      scheduleCall: false,
      completeCall: false,
      returnKit: false,
      personalScanReview: false,
      trainingCompletedCount: practitioner.trainingCompletedCount || 0,
      totalTraining: TrainingContentContext.length,
    };

    if (practitioner.onboarding && Array.isArray(practitioner.onboarding)) {
      practitioner.onboarding.forEach((step) => {
        if (step in onboarding) {
          onboarding[step] = true;
        }
      });
    }

    return onboarding;
  };

  return (
    <TruCard title={'Onboarding Status'}>
      <div style={theme.Container.listColumn}>
        {sortedPractitionerList != null &&
          sortedPractitionerList.map((p) => {
            const onboarding = buildOnboardingObject(p); // Build onboarding object
            if (!p.onboardingComplete) {
              return (
                <OnboardingStatusItem
                  key={p.id}
                  name={`${p.lastName}, ${p.firstName}`}
                  onboarding={onboarding} // Pass onboarding object
                  actionLink={() => navigate(`/practitioners/${p.id}`)}
                />
              );
            }
          })}
      </div>
    </TruCard>
  );
}